<ng-template #summaryItem let-image="image" let-label="label" let-value="value" let-iconBg="iconBg">
    <div class="flex items-center gap-2 max-h-6">
        <div class="aspect-square h-fit w-fit rounded-full p-1.5" [style.background-color]="'#E2F2FC'">
            <img [src]="image" [alt]="label" class="h-4 w-4 max-md:size-3" />
        </div>

        <p>
            <span class="text-xs md:text-sm font-normal text-[#344054]">
                {{ label }}:
            </span>

            <span [title]="value" [innerHTML]="value" class="inline-block md:text-sm text-xs font-medium text-[#101828]">
            </span>
        </p>
    </div>
</ng-template>

<div
    class="rounded-[10px] border border-[#E4E7EC] bg-[#F9FAFB] px-2.5 py-4 max-md:p-3"
    *transloco="let t; currentLang as currentLang">
    <div class="grid grid-cols-1 items-center gap-x-1 gap-y-3 md:px-3 sm:grid-cols-2 md:grid-cols-3">
        <div class="max-h-6">
            <ng-container [ngTemplateOutlet]="summaryItem" [ngTemplateOutletContext]="{
          image: 'images/vacancy.svg',
          label: t('vaccancy'),
          value:
            jobDetails()?.JobVacancies === 'NA'
              ? '--'
              : currentLang === 'bn'
                ? ((jobDetails()?.JobVacancies ?? '') | toBanglaNumber)
                : jobDetails()?.JobVacancies
        }" /></div>
        
        <div class="max-h-6">
          <ng-container [ngTemplateOutlet]="summaryItem" [ngTemplateOutletContext]="{
                    image: 'images/type.svg',
                    label: t('Age'),
                    value:
                      !jobDetails()?.Age || jobDetails()?.Age === 'Na'
                        ? 'N/A'
                        : currentLang === 'bn'
                          ? ((jobDetails()?.Age ?? '') | toBanglaNumber)
                          : jobDetails()?.Age
                  }" />
        </div>
        <!-- @if (jobDetails()?.JobLocation) { -->
        <!-- Location -->
        <div>
          @if (isMultipleLocations()) {
          <div class="flex items-center gap-2 cursor-pointer" (click)="locationClicked.emit()">
            <div class="aspect-square h-fit w-fit rounded-full p-1.5" style="background-color:#E2F2FC">
              <img src="images/location-pin.svg" [alt]="t('Location')" class="h-4 w-4 max-md:size-3" />
            </div>
            <p>
              <span class="text-xs md:text-sm font-normal text-[#344054]">{{ t('Location') }}:</span>
              <span [title]="jobDetails()?.JobLocation"
                class="inline-block md:text-sm p-1.5 text-xs font-medium text-[#0E73A9] underline">
                {{ t('multipleLocations') }}
              </span>
            </p>
          </div>
          } @else if (jobDetails()?.JobLocation) {
          <div class="flex items-center gap-2 cursor-pointer" (click)="locationClicked.emit()">
            <div class="aspect-square h-fit w-fit rounded-full p-1.5" style="background-color:#E2F2FC">
              <img src="images/location-pin.svg" [alt]="t('Location')" class="h-4 w-4 max-md:size-3" />
            </div>
            <p>
              <span class="text-xs md:text-sm font-normal text-[#344054]">{{ t('Location') }}:</span>
              <span [title]="jobDetails()?.JobLocation"
                class="inline-block md:text-sm text-xs font-medium text-[#101828] hover:text-[#0E73A9] hover:underline">
                {{ jobDetails()?.JobLocation | truncate:25 }}
              </span>
            </p>
          </div>
          } @else {
          <ng-container [ngTemplateOutlet]="summaryItem" [ngTemplateOutletContext]="{
              image: 'images/location-pin.svg',
              label: t('Location'),
              value: 'N/A'
            }" />
          }
        </div>
        <!-- } -->

        <div class="max-h-6">
          <ng-container [ngTemplateOutlet]="summaryItem" [ngTemplateOutletContext]="{
            image: 'images/taka.svg',
            label: t('salary_summary'),
            value:
              !jobDetails()?.JobSalaryRange || jobDetails()?.JobSalaryRange === '--'
                ? 'N/A'
                : currentLang === 'bn'
                  ? ((jobDetails()?.JobSalaryRange ?? '') | toBanglaNumber)
                  : jobDetails()?.JobSalaryRange
          }" />
        </div>

      <div class="max-h-6">
        <ng-container [ngTemplateOutlet]="summaryItem" [ngTemplateOutletContext]="{
          image: 'images/briefcase.svg',
          label: t('Exp'),
          value:
            !experience()
              ? 'N/A'
              : currentLang === 'bn'
                ? (experience() | toBanglaNumber)
                : experience()
        }" />
      </div>

        @if (
        jobDetails()?.PostedOn &&
        jobDetails()?.PostedOn !== defaultPublishDate
        ) {
        <div class="max-h-6">
            <ng-container [ngTemplateOutlet]="summaryItem" [ngTemplateOutletContext]="{
            image: 'images/calendar-blue.svg',
            label: t('Published'),
            value:
              currentLang === 'bn'
                ? (((jobDetails()?.PostedOn | date:'dd MMM yyyy') ?? '') | toBanglaNumber)
                : (jobDetails()?.PostedOn | date:'dd MMM yyyy')
          }" />
        </div>
        }

    </div>
</div>